var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgCriterionNone = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8002 8.9L13.4002 9.2C12.7002 9.2 12.0002 8.7 11.9002 7.9L11.7002 5.5H11.8002L15.8002 8.9Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7002 17.6996C16.8002 18.4996 16.2002 19.1996 15.5002 19.1996L8.00016 19.9996H7.90016H7.70016C6.90016 20.0996 6.20016 19.4996 6.20016 18.7996L5.00016 7.59961C4.90016 6.79961 5.50016 6.09961 6.30016 6.09961L11.6002 5.59961H11.7002L11.9002 7.89961C11.9002 8.09961 12.0002 8.29961 12.0002 8.39961C12.1002 8.49961 12.2002 8.69961 12.3002 8.79961C12.7002 9.09961 13.0002 9.19961 13.4002 9.19961H13.6002H13.7002L15.7002 8.99961L16.7002 17.6996Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4003 8.89961L15.9003 8.99961H15.8003L14.0003 9.19961C13.9003 9.19961 13.8003 9.19961 13.8003 9.19961C13.1003 9.19961 12.6003 8.59961 12.5003 7.99961L12.3003 6.09961V5.99961V5.59961H12.4003L16.4003 8.89961Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7003 17.6996C16.8003 18.4996 16.2003 19.1996 15.5003 19.1996L8.00026 19.9996C7.40026 19.8996 6.80026 19.3996 6.80026 18.7996L5.60026 7.59961C5.50026 6.79961 6.10026 6.09961 6.90026 6.09961L11.7003 5.59961H11.8003H12.1003H12.2003V5.99961V6.09961L12.4003 7.89961C12.5003 8.59961 13.0003 9.09961 13.7003 9.09961C13.8003 9.09961 13.9003 9.09961 13.9003 9.09961L15.8003 8.99961L16.7003 17.6996Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 8.3H16.3998C15.4998 8.3 14.7998 7.6 14.7998 6.7V4L14.8998 4.1L19.0998 8.3Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 8.3V18.4C19.1 19.3 18.4 20 17.5 20H8.6C7.7 20 7 19.3 7 18.4V5.6C7 4.7 7.7 4 8.6 4H14.7H14.8V6.7C14.8 7.6 15.5 8.3 16.4 8.3H19.1Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1002 8.3V18.4C19.1002 19.3 18.4002 20 17.5002 20H9.3002C8.4002 20 7.7002 19.3 7.7002 18.4V5.6C7.7002 4.7 8.4002 4 9.3002 4H14.6002H14.7002V6.7C14.7002 7.6 15.4002 8.3 16.3002 8.3H19.1002Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9001 12.6C12.9001 12.6 13.0001 12.5 13.1001 12.5C13.5001 12.5 13.8001 12.4 14.0001 12.2C14.2001 12 14.4001 11.7 14.4001 11.4C14.4001 11.1 14.3001 10.8 14.1001 10.6C13.9001 10.4 13.6001 10.3 13.3001 10.3C13.1001 10.3 13.0001 10.3 12.8001 10.4C12.6001 10.5 12.5001 10.6 12.3001 10.7C12.2001 10.8 12.1001 10.8 12.0001 10.8C11.9001 10.8 11.9001 10.8 11.8001 10.7C11.7001 10.7 11.6001 10.6 11.6001 10.4C11.6001 10.3 11.6001 10.2 11.7001 10.1C11.9001 10 12.1001 9.8 12.4001 9.7C12.7001 9.6 13.0001 9.5 13.3001 9.5C13.7001 9.5 14.0001 9.6 14.3001 9.7C14.6001 9.9 14.8001 10.1 15.0001 10.4C15.2001 10.7 15.3001 11 15.3001 11.4C15.3001 11.7 15.2001 12 15.1001 12.3C15.0001 12.6 14.8001 12.8 14.5001 12.9C14.1001 13 13.8001 13.1 13.5001 13.2V13.7C13.5001 13.8 13.5001 13.9 13.4001 14C13.3001 14.1 13.2001 14.1 13.1001 14.1C13.0001 14.1 12.9001 14.1 12.8001 14C12.8001 13.9 12.7001 13.8 12.7001 13.7V12.9C12.7001 12.8 12.8001 12.7 12.9001 12.6ZM12.8001 15.5C12.7001 15.4 12.7001 15.3 12.7001 15.2V15C12.7001 14.9 12.7001 14.8 12.8001 14.7C12.9001 14.6 13.0001 14.6 13.1001 14.6H13.2001C13.3001 14.6 13.4001 14.6 13.5001 14.7C13.6001 14.8 13.6001 14.9 13.6001 15V15.2C13.6001 15.3 13.6001 15.4 13.5001 15.5C13.4001 15.6 13.3001 15.6 13.2001 15.6H13.1001C13.0001 15.6 12.9001 15.6 12.8001 15.5Z",
    fill: "url(#paint5_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.6801,
    y1: 9.19992,
    x2: 13.4942,
    y2: 7.4643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16.2383,
    y1: 4.49763,
    x2: 8.64956,
    y2: 15.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 18.4968,
    y1: 4.7099,
    x2: 13.1813,
    y2: 9.5421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 17.5495,
    y1: 8.2294,
    x2: 0.516001,
    y2: 22.3636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 17.7142,
    y1: 2.8036,
    x2: 2.7344,
    y2: 34.6961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 12.8088,
    y1: 9.0539,
    x2: 14.58,
    y2: 15.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCriterionNone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CriterionNone.7e274ec2.svg";
export { ForwardRef as ReactComponent };